import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { release, notImplemented, somewhatImplemented, toKeyValueArray } from '@awayfl/swf-loader';
import { TouchscreenType } from './TouchscreenType';
export var DEFAULT_CAPABILITIES = {
    LANGUAGE: 'en',
    PLAYER_TYPE: 'PlugIn',
    SCREEN_DPI: 96,
    IS_DEBUGGER: false,
};
var Capabilities = /** @class */ (function (_super) {
    __extends(Capabilities, _super);
    function Capabilities() {
        return _super.call(this) || this;
    }
    Object.defineProperty(Capabilities, "isEmbeddedInAcrobat", {
        // static _touchscreenType: string;
        // static _hasIME: boolean;
        // static _hasTLS: boolean;
        // static _maxLevelIDC: string;
        // static _supports32BitProcesses: boolean;
        // static _supports64BitProcesses: boolean;
        // static __internal: number /*uint*/;
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasEmbeddedVideo", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get hasEmbeddedVideo');
            return;
            // return Capabilities._hasEmbeddedVideo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasAudio", {
        get: function () {
            // The documentation says "this property is always true".
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "avHardwareDisable", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get avHardwareDisable');
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasAccessibility", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get hasAccessibility');
            return Capabilities._hasAccessibility;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasAudioEncoder", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get hasAudioEncoder');
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasMP3", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get hasMP3');
            return;
            // return Capabilities._hasMP3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasPrinting", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get hasPrinting');
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasScreenBroadcast", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get hasScreenBroadcast');
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasScreenPlayback", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get hasScreenPlayback');
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasStreamingAudio", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get hasStreamingAudio');
            return;
            // return Capabilities._hasStreamingAudio;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasStreamingVideo", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get hasStreamingVideo');
            return;
            // return Capabilities._hasStreamingVideo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasVideoEncoder", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get hasVideoEncoder');
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "isDebugger", {
        get: function () {
            return DEFAULT_CAPABILITIES.IS_DEBUGGER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "localFileReadDisable", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get localFileReadDisable');
            return;
            // return Capabilities._localFileReadDisable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "language", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get language');
            return Capabilities._language || DEFAULT_CAPABILITIES.LANGUAGE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "manufacturer", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get manufacturer');
            return Capabilities._manufacturer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "os", {
        get: function () {
            if (Capabilities._os === null) {
                var os = void 0;
                var userAgent = window.navigator.userAgent;
                if (userAgent.indexOf('Macintosh') > 0) {
                    if (userAgent.indexOf('Mac OS X ') === -1) {
                        os = 'Mac OS 10.6';
                    }
                    else {
                        var versionStr = userAgent.split('Mac OS X ')[1];
                        os = versionStr.substr(0, versionStr.indexOf(';'));
                    }
                }
                else if (userAgent.indexOf('Windows') > 0) {
                    os = 'Windows XP';
                }
                else if (userAgent.indexOf('Linux') > 0) {
                    os = 'Linux';
                }
                else if (/(iPad|iPhone|iPod|Android)/.test(userAgent)) {
                    os = 'iPhone3,1';
                }
                else {
                    release || somewhatImplemented('public flash.system.Capabilities::get os');
                    os = 'Generic OS';
                }
                Capabilities._os = os;
            }
            return Capabilities._os;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "cpuArchitecture", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get cpuArchitecture');
            return 'x86';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "playerType", {
        get: function () {
            return Capabilities._playerType || DEFAULT_CAPABILITIES.PLAYER_TYPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "serverString", {
        get: function () {
            var str = toKeyValueArray({ OS: Capabilities.os }).map(function (pair) {
                return pair[0] + '=' + encodeURIComponent(pair[1]);
            }).join('&');
            release || somewhatImplemented('Capabilities.serverString: ' + str);
            return str;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "version", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get version');
            return Capabilities._version;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "screenColor", {
        /**
       * This can be "color", "gray" or "bw" for black and white. I don't know when you'd have anything
       * other than "color".
       */
        get: function () {
            return 'color';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "pixelAspectRatio", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get pixelAspectRatio');
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "screenDPI", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get screenDPI');
            return Capabilities._screenDPI || DEFAULT_CAPABILITIES.SCREEN_DPI;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "screenResolutionX", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get screenResolutionX');
            return window.screen.width; // TODO check
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "screenResolutionY", {
        get: function () {
            release || somewhatImplemented('public flash.system.Capabilities::get screenResolutionY');
            return window.screen.height; // TODO check
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "touchscreenType", {
        get: function () {
            return TouchscreenType.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasIME", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "hasTLS", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get hasTLS');
            return;
            // return Capabilities._hasTLS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "maxLevelIDC", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get maxLevelIDC');
            return;
            // return Capabilities._maxLevelIDC;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "supports32BitProcesses", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get supports32BitProcesses');
            return;
            // return Capabilities._supports32BitProcesses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "supports64BitProcesses", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get supports64BitProcesses');
            return;
            // return Capabilities._supports64BitProcesses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Capabilities, "_internal", {
        get: function () {
            release || notImplemented('public flash.system.Capabilities::get _internal');
            return;
            // return Capabilities.__internal;
        },
        enumerable: false,
        configurable: true
    });
    Capabilities.hasMultiChannelAudio = function (type) {
        release || somewhatImplemented('public flash.system.Capabilities::static hasMultiChannelAudio');
        return false;
    };
    Capabilities.classInitializer = null;
    // static _hasEmbeddedVideo: boolean;
    // static _hasAudio: boolean;
    // static _avHardwareDisable: boolean;
    Capabilities._hasAccessibility = false;
    // static _hasAudioEncoder: boolean;
    // static _hasMP3: boolean;
    // static _hasPrinting: boolean;
    // static _hasScreenBroadcast: boolean;
    // static _hasScreenPlayback: boolean;
    // static _hasStreamingAudio: boolean;
    // static _hasStreamingVideo: boolean;
    // static _hasVideoEncoder: boolean;
    // static _localFileReadDisable: boolean;
    Capabilities._language = null; // DEFAULT_CAPABILITIES.LANGUAGE;
    Capabilities._manufacturer = 'Mozilla Research';
    Capabilities._os = null;
    // static _cpuArchitecture: string;
    Capabilities._playerType = null; // DEFAULT_CAPABILITIES.PLAYER_TYPE;
    Capabilities._version = 'SHUMWAY 10,0,0,0';
    // static _screenColor: string;
    // static _pixelAspectRatio: number;
    Capabilities._screenDPI = 0; // = DEFAULT_CAPABILITIES.SCREEN_DPI;
    return Capabilities;
}(ASObject));
export { Capabilities };
